import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Icon, Text } from '@maui/elements'
import { DisclosureContent, useDisclosureState } from 'reakit'

export const ServiceDetailsSummary = ({ description }) => {
  const disclosure = useDisclosureState({ visible: true })
  return (
    <>
      <ExpandSummaryButton {...disclosure} />
      <DisclosureContent {...disclosure}>
        {
          description
            ? <ShortenedSummary>{description}</ShortenedSummary>
            : ''
        }
      </DisclosureContent>
    </>
  )
}

ServiceDetailsSummary.propTypes = {
  description: PropTypes.string.isRequired,
}

function ExpandSummaryButton({ toggle, visible }) {
  const iconProps = {
    name: visible ? 'chevron-down-circle' : 'chevron-right-circle',
  }
  return (
    <Box display="inline-flex" alignItems="center">
      <Button
        id="expand-summary"
        onClick={() => toggle()}
        bg="transparent"
        border="0"
        p="10px 10px 6px 0"
        ariaLabel="Expand to see more"
        _hover={{ backgroundColor: 'transparent' }}
        _active={{ backgroundColor: 'transparent' }}
      >
        <Icon {...iconProps} color="colorActionPrimary" />
      </Button>
      <Text
        as="label"
        htmlFor="expand-summary"
        color="colorTextMain"
        variant="heading5"
        cursor="pointer"
      >
                  Summary
      </Text>
    </Box>
  )
}

ExpandSummaryButton.propTypes = {
  toggle: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
}

function ShortenedSummary({ children }) {
  const maxLength = 200
  const showButton = children.length > maxLength
  const [summaryString, setSummaryString] = React.useState(
    children.substring(0, maxLength)
  )
  const shortenSummaryString = () => {
    if (children.length === summaryString.length) {
      setSummaryString(children.substring(0, maxLength))
    } else {
      setSummaryString(children)
    }
  }
  return (
    <Box>
      <Text as="p" color="colorTextMain" m="0">
        {summaryString}{' '}
        {showButton && (
          <Button
            display="inline"
            variant="primaryText"
            p="0"
            m="0"
            onClick={shortenSummaryString}
          >
            {' '}
                          (show more)
          </Button>
        )}
      </Text>
    </Box>
  )
}

ShortenedSummary.propTypes = {
  children: PropTypes.string.isRequired,
}
